import request from './request';

export default {
  getUniPayAppSign(url) {
    return request.post({
      action: 'hitch.external.unionpay.upsdk',
      url,
    }, {}, false).then((res) => res.data);
  },
};
